(function () {
  'use strict';
  if (window.PromoPricing) return;

  /**
   * Active promo tag prefix, lowercased, or empty string when promo pricing is off.
   * @returns {string}
   */
  function getPrefix() {
    const prefix = window.themeSettings && window.themeSettings.promoTagPrefix;
    return typeof prefix === 'string' ? prefix.toLowerCase().trim() : '';
  }

  /**
   * Highest promo percent encoded in a product's tags (`<prefix><int>`), or 0.
   * @param {string[]|string|null|undefined} tags - Product tags (array, or comma-joined string).
   * @returns {number}
   */
  function percentFromTags(tags) {
    const prefix = getPrefix();
    if (!prefix) return 0;
    const list = Array.isArray(tags) ? tags : typeof tags === 'string' ? tags.split(',') : [];
    let percent = 0;
    list.forEach(function (raw) {
      const tag = String(raw).trim().toLowerCase();
      if (!tag.startsWith(prefix)) return;
      const value = parseInt(tag.slice(prefix.length), 10);
      if (Number.isInteger(value) && value > percent && value < 100) percent = value;
    });
    return percent;
  }

  /**
   * Unit price after a percentage discount. Shopify floors the per-unit discount
   * to the cent, so this matches the cart line price exactly.
   * @param {number} priceCents - Unit price in integer cents.
   * @param {number} percent - Whole-number percent off.
   * @returns {number} Discounted unit price in integer cents.
   */
  function applyPercent(priceCents, percent) {
    const price = Math.round(priceCents) || 0;
    if (!percent || price <= 0) return price;
    return price - Math.floor((price * percent) / 100);
  }

  /**
   * Resolve the promo for a product from its current unit price. Already-reduced
   * products are included: the automatic discount applies to the sale price, so
   * the promo is always computed from the price the shopper sees today.
   * @param {{ priceCents: number, tags?: string[]|string }} input
   * @returns {{ percent: number, priceCents: number }|null} null when no promo applies.
   */
  function resolve(input) {
    if (!input) return null;
    const price = Math.round(input.priceCents) || 0;
    if (price <= 0) return null;
    const percent = percentFromTags(input.tags);
    if (!percent) return null;
    return { percent: percent, priceCents: applyPercent(price, percent) };
  }

  /**
   * Promo message with placeholders filled.
   * @param {string} formattedPrice - Promo price already formatted for display.
   * @param {number} percent - Whole-number percent off.
   * @returns {string} Empty string when no template is configured.
   */
  function message(formattedPrice, percent) {
    const template = window.themeSettings && window.themeSettings.promoMessage;
    if (typeof template !== 'string' || !template.trim()) return '';
    return template.split('[price]').join(formattedPrice).split('[percent]').join(String(percent));
  }

  window.PromoPricing = Object.freeze({ percentFromTags, applyPercent, resolve, message });
})();
